import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNotificationChannel } from '@dialectlabs/react-sdk';
import clsx from 'clsx';
import { useState } from 'react';
import { Button } from '../../../common';
import { P } from '../../../common/preflighted';
import { useTheme } from '../../../common/providers/DialectThemeProvider';
import ResendIcon from '../../../Icon/Resend';
import CancelIcon from '../../../Icon/Cancel';
import OutlinedInput from '../../../common/primitives/OutlinedInput';
const VERIFICATION_CODE_REGEX = '^[0-9]{6}$';
export const VerificationInput = ({ addressType, onCancel, description, customText, }) => {
    const [verificationCode, setVerificationCode] = useState('');
    const [currentError, setCurrentError] = useState(null);
    const { verify: verifyCode, resend } = useNotificationChannel({
        addressType,
    });
    const { textStyles, adornmentButton } = useTheme();
    const sendCode = async () => {
        try {
            await verifyCode({ code: verificationCode });
            setCurrentError(null);
        }
        catch (e) {
            setCurrentError(e);
        }
        finally {
            setVerificationCode('');
        }
    };
    const resendCode = async () => {
        try {
            await resend();
            setCurrentError(null);
        }
        catch (e) {
            setCurrentError(e);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(OutlinedInput, { id: "settings-verification-cide", placeholder: "Enter verification code", type: "text", value: verificationCode, onChange: (e) => setVerificationCode(e.target.value), onBlur: (e) => e.target.checkValidity()
                    ? setCurrentError(null)
                    : setCurrentError({
                        name: 'incorrectEmail',
                        message: 'Please enter a valid email',
                    }), onInvalid: (e) => {
                    e.preventDefault();
                    setCurrentError({
                        name: 'incorrectEmail',
                        message: 'Please enter a valid email',
                    });
                }, pattern: VERIFICATION_CODE_REGEX, rightAdornment: _jsx(Button, { onClick: sendCode, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Submit" }) }), _jsx("div", { className: clsx(textStyles.small, 'dt-inline-flex dt-items-center', 'dt-mb-1 dt-mt-1'), children: customText ? (customText) : (_jsxs(_Fragment, { children: [_jsx("span", { className: "dt-opacity-50", children: description }), _jsxs("span", { onClick: onCancel, className: "dt-inline-flex dt-items-center dt-cursor-pointer", children: [_jsx(CancelIcon, { className: clsx('dt-inline-block dt-mr-0.5 dt-mb-0.5'), height: 14, width: 14 }), "Cancel"] }), _jsxs("span", { onClick: resendCode, className: "dt-inline-flex dt-items-center dt-cursor-pointer", children: [_jsx(ResendIcon, { className: clsx('dt-inline-block dt-ml-1 dt-mr-0.5 dt-mb-0.5'), height: 14, width: 14 }), "Resend code"] })] })) }), currentError && (_jsx(P, { className: clsx(textStyles.small, 'dt-text-red-500 dt-mt-2'), children: currentError.message }))] }));
};
//# sourceMappingURL=VerificationInput.js.map